import React, { useContext } from "react";
import { Avatar, Box, Tooltip, Typography } from "@mui/material";
import { ThemeContext } from "../../context/ThemeContext";
import { getShortName, isEmpty, stringAvatar, stringToColor } from "../../utilities/globalServiceUtils";

const UserName = ({
  name,
  email = "",
  picture = null,
  onClick = null,
  cursor = "pointer",
  size = 25,
  shortName = false,
  showName = true,
  showTooltip = false,
  tooltipText = "",
}) => {
  const themeCtx = useContext(ThemeContext) || {};
  const flexRow = themeCtx.flexRow || { display: "flex", flexDirection: "row" };

  const renderUserAvatar = () => {
    if (!isEmpty(picture)) {
      return (
        <Avatar
          src={picture}
          alt={name || "User"}
          sx={{ width: size, height: size, cursor }}
          onClick={onClick ?? null}
        />
      );
    }
    return <Avatar {...stringAvatar(name || "NA", size, size, 12)} />;
  };

  const renderUserName = () => (
    <Box sx={{ ...flexRow, justifyContent: "flex-start", alignItems: "center", columnGap: "5px", cursor }}>
      {renderUserAvatar()}
      {email ? (
        <>
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: "flex-start", alignItems: "flex-start", columnGap: "6px", cursor }}>
            {showName && (
              <Typography variant="body1" fontSize={"12px"}>{shortName ? getShortName(name || "") : name || "NA"}</Typography>
            )}
            <Typography variant="body1" fontSize={"11px"} color="text.secondary">{email}</Typography>
          </Box>
        </>
      ) : (
        <>
          {showName && (
            <Typography variant="body1" fontSize={"12px"}>{shortName ? getShortName(name || "") : name || "NA"}</Typography>
          )}
        </>
      )}
    </Box>
  );

  if (showTooltip) {
    return (
      <Tooltip title={isEmpty(tooltipText) ? name || "NA" : tooltipText} placement="bottom" arrow>
        {renderUserName()}
      </Tooltip>
    );
  }
  return renderUserName();
};

export default UserName;

